import { ReactNode } from "react"
import { Box, useMediaQuery, useTheme } from "@mui/material"
import { useSelector } from "react-redux"
import { RootState } from "../app/store"
import { Header } from "./Header"
import { MobileBottomNav } from "./MobileBottomNav"
import { BOTTOM_NAV_HEIGHT, HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from "./layoutConstants"
import { uiTokens } from "../common/uiTokens"

type AppShellProps = {
  children: ReactNode
  showHeader: boolean
}

export function AppShell({ children, showHeader }: AppShellProps) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const user = useSelector((state: RootState) => state.user)
  const headerHeight = isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP
  const showBottomBar = showHeader && isMobile && user.user != null

  return (
    <Box
      sx={{
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: uiTokens.colors.background,
        color: uiTokens.colors.textPrimary,
      }}
    >
      {showHeader && <Header />}
      <Box
        component="main"
        sx={{
          flex: "1 1 auto",
          overflowY: "auto",
          paddingTop: showHeader ? `calc(${headerHeight}px + env(safe-area-inset-top))` : 0,
          paddingBottom: showBottomBar
            ? `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom))`
            : "env(safe-area-inset-bottom)",
        }}
      >
        {children}
      </Box>
      {showBottomBar && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            paddingBottom: "env(safe-area-inset-bottom)",
            backgroundColor: uiTokens.colors.background,
            boxShadow: "0 -8px 18px rgba(46, 42, 38, 0.08)",
            zIndex: theme.zIndex.appBar,
          }}
        >
          <MobileBottomNav isVisible={showBottomBar} />
        </Box>
      )}
    </Box>
  )
}
